import {doc, getDoc, setDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { getCollection } from "./data"

export class Chemical
{
	constructor(name)
	{
		this.name = name;
		this.id = name;
	}

	async submitAsNew()
	{
		const {id, ...rest} = this;
		var projectRef = doc(db, "Chemicals", id);
		let snapshot = await getDoc(projectRef);
		if (!snapshot.exists()) {
			let resp = await setDoc(doc(db, "Chemicals", id), { ...rest });
			return resp;
		}
	}

	static async getAll()
	{
		return await getCollection("Chemicals");
	}

	static async deleteAndUpdate(selection,chemicals,setChemicals)
	{
		chemicals = chemicals.filter( project=>{
			const key = project.id;
			if(selection.includes(key))
			{
				const activityRef = doc(db, "Chemicals", key);
				deleteDoc(activityRef);
				return false;
			}
			return true;
		});
		setChemicals(chemicals);
	}
}